import { getCurrentInstance } from "vue";
var current = 0;

function useId() {
  var vm = getCurrentInstance();

  var _ref = (vm == null ? void 0 : vm.type) || {},
      _ref$name = _ref.name,
      name = _ref$name === void 0 ? "unknown" : _ref$name;

  if (process.env.NODE_ENV === "test") {
    return name;
  }

  return "".concat(name, "-").concat(++current);
}

export { useId };